
import { Vue, Component, Prop } from "vue-property-decorator";
import Model from "./model";
import Common from "../../commonUtil/common";
import MenuComponents from "@/components/menu.vue";
import PageComponents from "@/components/page.vue";
import axios from "axios";

// 必须使用@Component注解
@Component({
  components: {
    MenuComponents,
    PageComponents,
  },
})
export default class funDetailDataVue extends Vue {
  private model = new Model();
  
  private common = new Common();

  private form: any = {
    title: '',
    batchId: '', //批次id
    value: [],  // 所有数据
    typeArr: [], // 所有类型组件
    idArr: [],
    detailIdArr: [],
    typeName: '',
    typeValue: '',
  };

  // 自动列宽度
  private colWidth: number = 80;

    // 列集合
  private tableColumnList: any = null;

  private tableData: any = new Array;

  // 图片host
  private picHost: string = "";

  private fileList: any = []; // 暂存所有上传的图片

  // 功能名称
  private funName: any = "";

  // 新建窗口是否显示的标记
  public dialogFormVisible: boolean = false;

  // 所有下拉
  private typeOptions: any = null;

  // 新建时，所有组件，id是funDetail表的id
  private allControlList: any = null;

  // 分页插件用的属性
  public pageBean = {
    current: 1,
    size: 10,
    pages: 0, // 总页数
    total: 0, // 总记录条数
  };

  // 分页请求参数
  private pageParam = {
    data: {
      id: '', // 属性详情的主键
      funId: '',
      batchId: '',
      detailId: '',
      name: '',
     
    },
    likeMap:{
       value: '',
    },
    pageBean: this.pageBean,
  };


  public downloadStream(streamBlob: Blob, fileName: string) {
    const src = window.URL.createObjectURL(streamBlob)
    let aDom: HTMLAnchorElement | null = document.createElement('a')
    aDom.href = src
    aDom.setAttribute('download', fileName)
    aDom.click()
    aDom = null
}


    //下载
    public async downflie(url: string){  //item.attachments是附件。
      const kuozhanName: any = this.getKuoZhanNameByUrl(url);
      let params = {
        url: url,
        fileName: "附件" + kuozhanName
      }

      await this.model.downloadFile(params);     
    }

  // 下载附件
  private async downloadFile(url: any){
    let param = {
      url:url,
    }
    // 下载前先校验文件是否存在，不存在时，提示
    const data = await this.model.checkFile(param);
    if(data.code == 300){
      Vue.prototype.$message.error(data.message);
    }else{
      await this.downflie(url);
    }
    
  }

  // 判断字符串是否是文件扩展名结尾
  private isFileEnd(file: string){
    let fileArr: string[] = ".jpg,.png,.jpeg,.zip,.rar,.pdf,.docx,.doc,.xlsx,.xls,.mp3".split(",");
    let url: string = file;
    if (url === undefined) {
      return false;
    }
    for(let file in fileArr){
      const fileN: string = fileArr[file];
      if(url.indexOf(".")>0){
        const kuozhanName: any = this.getKuoZhanNameByUrl(url);
        if(fileN == kuozhanName){
          return true;
        }
      }else{
        return false;
      }
    }
    return false;
  }
 
  // 根据url获取文件扩展名
  private getKuoZhanNameByUrl(url: string){
    if(url.indexOf(".")>0){
        const kuozhanName: any = "." + url.split(".").pop();
        return kuozhanName;
    }else{
      return null;
    }
  }
  
  // 判断是否显示下载按钮
  public isShowDownload(item: any, val: string){
    // val的值是列名歌曲、时间等，不带有Type字符串
      for (let key in item) {
        if (key == val+'Type') {
          const typeVal = item[key];
          //console.log("666:" + typeVal);
          if(typeVal==6){
              return true;
          }
        }
    }
    return false;
  }

  

  // 图片上传成功后，会回调该方法，返回图片的url
  private async handleAvatarSuccess(response: any, file: any,index:any) {
    // 设置图片的值
    this.form.value[index] = this.picHost + '/' + response.data.picId;
    console.log("aaa:" + this.form.value[index])
    this.$forceUpdate() ;
  }

  private async handleAvatarSuccessFile(response: any, file: any, index:any) {
    if(response.code==300){
      Vue.prototype.$message.error('文件类型不支持!');
      return ;
    }else{
      // 设置图片的值
      this.form.value[index] = [{
        name: "附件",
        url: response.data.picId
      }]
      // this.form.value[index] = this.picHost + "/" + response.data.picId;
      this.$forceUpdate() ;
    }
  }

  // 附件！！，页面点击删除附件时调用
  private async removeFile(index: string){
    // private async removeFile(file: any, fileList: any){
    let url = this.form.value[index][0].url;
    const fileName = url.split("/").pop();
    let params = {
      fileName: fileName,
    }
    const result = await this.model.deleteFileByName(params);
      if (result != null) {
        // 将附件数组置空
        this.form.value[index] = [];
        // 删除后端文件
        this.$forceUpdate() ;
      }
  }
  
  // 删除图片
  private async deletePicByFileName(index: any){
    let url: string = this.form.value[index];
    if(url){
      const fileName = url.split("/").pop();
      const param = {
        fileName: fileName
      }
      const result = await this.model.deleteFileByName(param);
      if (result != null) {
        // 将图片的值置空
        this.form.value[index] = "";
        this.$forceUpdate() ;
      }
    }
  }

  // 选择附件，发生异常时，一般是超过限制上传总数时调用该方法
  private async handleExceed(files: any, fileList: any) {
    Vue.prototype.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`,
    );
  }

  // 上传前验证是否合法
  // 只能是图片，小于10M
  private async beforeUploadPic(file: any) {
    return new Promise((resolve, reject) => {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' );
      const maxSize = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        Vue.prototype.$message.error('上传图片只能是 jpg/png 格式!');
      }
      if (!maxSize) {
        Vue.prototype.$message.error('上传图片大小不能超过 10MB!');
      }
      // return isJPG && isPNG && maxSize;
      const flag = isJPG && maxSize;
      return resolve(flag);
    });
  }

  // 校验附件
  private async beforeUploadFile(file: any, index: any) {
    return new Promise((resolve, reject) => {
      console.log("type::", file.type);
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type == 'application/zip' 
      || file.type == 'application/rar' || file.type == 'application/pdf'  
      || file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
      || file.type == 'application/msword' 
      || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      || file.type == 'application/vnd.ms-excel' 
      || file.type == 'audio/mpeg'
      
      );
      const maxSize = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        Vue.prototype.$message.error('上传附件只能是 jpg/png/zip/rar/pdf/doc/docx/xls/xlsx/mp3 格式!');
        this.form.value[index] = [];
      }
      if (!maxSize) {
        Vue.prototype.$message.error('上传附件大小不能超过 10MB!');
        this.form.value[index] = [];
      }
      // return isJPG && isPNG && maxSize;
      const flag = isJPG && maxSize;
      return resolve(flag);
    });
  }


  // 主页列表，查询所有列名map
  private async selectColumnMap() {
    await this.getControlTypeList();

    const param = {
      data:{
        funId: this.pageParam.data.funId,
      },
      pageBean: {
        current: 1,
        size: 1000,
      }
    }

    const result = await this.model.selectColumnMap(param);
    if (result != null) {
        this.tableColumnList = result.data;

        // this.tableColumnList = {
        //   date: "日期",
        //   name: "姓名",
        //   address: "地址",
        // }
    
    }
  }

  // 查弹出框需要展示的所有控件、值
  private async selectControlByFunId() {
    const param = {
      data:{
        funId: this.pageParam.data.funId,
      },
      pageBean: {
        current: 1,
        size: 1000,
      }
    }
    const result: any = await this.model.selectFunDetailPageData(param);
    
    let list = result.data.records;
    for(let item in list){
      if(list[item].type == '2'){
        // 为了查看方便，使用中文逗号
        list[item].typeValue = list[item].typeValue.split("，");
        // alert(list[item].typeValue);
      }
    }

    this.allControlList = list;
  }

  // 清空查询条件
  private async reset(){
    this.pageParam.data.id = '';
    this.pageParam.likeMap.value = '';
    
  }

  // 分页查询
  private async selectPageData() {
     // 主页列表，查询所有列名map
    await this.selectColumnMap();
    // 查询分页数据
    const result = await this.model.selectColumnAndDataMap(this.pageParam);
    
    if (result != null) {
      // this.tableData = result.data.dataList.map(item:any => 
      //   return {...item,
      //   flag:false
      //   }
      // );

      console.log(this.tableData);
      this.tableData = result.data.dataList;
      for(let tt of this.tableData){
        console.log("tt:" ,tt);
        tt.flag = false;
      }
      
      this.pageBean.pages = result.data.pages;
      this.pageBean.total = result.data.total;
      

      for(let ite of this.tableData){
        if(ite['名字']=="大师"){
          ite.flag = true;
        }
      }
      console.log(this.tableData);
        // this.tableData = [{
        //   date: '2016-05-02',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄',
        // }, {
        //   date: '2016-05-04',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1517 弄',
        // }]
    }
  }

  // 分页组件的值修改后，会调用该方法
  public async pageChange(data: any) {
    this.pageBean = data;
    await this.selectPageData();
  }

  // 获取一个字符串的长度，一个汉字算两个长度
  private getStrLen(str: string) {    
    ///<summary>获得字符串实际长度，中文2，英文1</summary>  
    ///<param name="str">要获得长度的字符串</param>  
    let realLength: number = 0;
    let len = str.length;
    let charCode = -1;  
    for (var i = 0; i < len; i++) {  
        charCode = str.charCodeAt(i);  
        if (charCode >= 0 && charCode <= 128) realLength += 1;  
        else realLength += 2;  
    }  
    return realLength;  
}    

  // 根据内容获取列宽
  private getWidth(row: any){
    if(row=="创建时间" || row=="更新时间"){
      return 155;
    }else if(this.getStrLen(row)>10){
      return 200;
    }else if(this.getStrLen(row)>5){
      return 120;
    }else{
      return 80;
    }
  }

  /** 查询条件的下拉框数据，查所有的 */
  private async getControlTypeList(){
    if (this.typeOptions!=null && this.typeOptions.length>0) {
      return ;
    }
    const param = {
			data:{
         funId: this.pageParam.data.funId,
      },
      pageBean: {
        current: 1,
        size: 100
      }
		};
		const result = await this.model.selectFunDetailPageData(param);
		this.typeOptions = result.data.records;
  }

  private async showDelete(row: any){
    const flag = await Vue.prototype.$confirm('确定删除吗？');
    if (flag) {
      let param = {
        data:{
          batchId: row.batchId
        }
      };
      const result = await this.model.removeByBatchId(param);
      if (result) {
        Vue.prototype.$message.success('删除成功');
        // 重新计算当前页
        this.common.recalculateCurrent(this.pageBean);
        await this.selectPageData();
      } else {
        Vue.prototype.$message.error('删除失败');
      }
    }
  }

  // // 根据码表code获取名称
  // private async getNameByCode(code: string){
  //   for (let item in this.typeOptions) {
  //     const flag = this.typeOptions[item].code == code;
  //       if (flag) {
  //         const name = this.typeOptions[item].name;
  //         return name;
  //       }
  //   }
  //   return '';
  // }

   
  // 弹出编辑框
  private async showUpdate(row: any) {
    // 查弹出框需要展示的所有控件、值
    await this.selectControlByFunId();

    const batchId = row.batchId;
    await this.getControlTypeList();

    let param = {
      data:{
        batchId: batchId
      }
    };

    // 查出具体数据
    const result = await this.model.selectPageData(param);

    let arr = result.data.records;
    debugger;
    this.form.value = [];
    for(let item in arr){
      console.log("type:" + arr[item].type);
      let fileObj: any = "";
      if(arr[item].type=='6'){
        if(arr[item].value){
          fileObj = [{
            name: '附件' + "." + arr[item].value.split(".").pop(),
            url: arr[item].value
          }]
        }
        this.form.value.push(fileObj);
      }else{
        this.form.value.push(arr[item].value);
      }
      // 值对应的组件的类型
      this.form.typeArr.push(arr[item].type);
      this.form.idArr.push(arr[item].id);
      this.form.detailIdArr.push(arr[item].detailId);
      
    }
    // alert(this.form.idArr);
    // alert(this.form.typeArr);
    
    this.form.batchId = row.batchId;
    this.form.title = '修改';
    this.dialogFormVisible = true;
  }

  // 弹出新增框
	private async showNew() {
    
    // 查弹出框需要展示的所有控件、值
    this.selectControlByFunId();
    
    this.form.title = '新增';
    this.form.batchId = ''; // 批次id置空
    this.form.value = [];   // 所有控件内数据清空
		this.dialogFormVisible = true;
	}

	// 保存，或者更新，后台都是先删除，再插入
	private async save() {

    // 所有组件，包含detailId属性
    //let arr = this.allControlList;

    const myuser: any = await this.common.getMyuser();
    console.log("myuser:" + myuser);
    const userId = myuser.id;

    let requestBean:any = {
      dataList:[]
    };
    
 

    // item是下标，allControlList的下标，对应this.form.value的下标（页面填写的值）
    for(let item in this.allControlList){
        // this.allControlList[item].id是功能详情表的id
        const detailId = this.allControlList[item].id;
        let value = this.form.value[item]  // 该值是一个字符串，在福建上传成功后，改成了一个字符串
        if(this.allControlList[item].type==6 ){
          if(value && value.length>0){
            value = value[0].url;
          }else{
            value = "";
          }
        }
        let param = {
          createUser: userId,
          updateUser: userId,
          batchId: this.form.batchId,
          detailId: detailId,
          value: value
        }
        requestBean.dataList.push(param);
    }
    // return;
    await this.model.saveBatch(requestBean);
    this.dialogFormVisible = false;

    this.pageBean.current = 1;

		this.selectPageData();
	}

  private async mounted() {
    console.log(this.$route.query);
    const funId: any = this.$route.query.funId;
    const funName: any = this.$route.query.name;
    this.funName = funName;
    this.pageParam.data.funId = funId;
     
    // 查询图片host，前缀信息
    let result = await this.model.getPicHost(null);
    this.picHost = result.data;

    // 分页查询列表数据
    await this.selectPageData();
  }

  // 跳转到上一页
  private async goHistory() {
    this.$router.go(-1);
  }

}
